<div mat-dialog-title>Submit Request</div>
<mat-dialog-content>You are going to submit this request.
  <br>After submitting, you won’t be able to make any changes.
  <br>Do you want to proceed?</mat-dialog-content>
<mat-dialog-actions>
  <div class="dialog-btn-row">
    <button class="btn btn-success" [mat-dialog-close]="true">Yes</button>
    <button class="btn btn-warning ml-sm" [mat-dialog-close]="false">No</button>
  </div>
</mat-dialog-actions>
